import React, {useRef, useState} from 'react';
import {Parallax, Navigation, Pagination, EffectCoverflow} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import Link from "@/Layouts/Link";
import '@/Pages/Collections/scss/envie/envieMobile.scss';

export default (props) => {
    const {uploadUrl = ''} = props;

    const videoRef = useRef(null);
    const swiperRef = useRef(null);

    const goNext = () => {
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
            swiperRef.current.swiper.slideNext();
        }
    };

    const goTop = () => {
        window.scrollTo(0, 0);
    }

    const goPrev = () => {
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    const [activeIndex, setActiveIndex] = useState(localStorage.getItem('activeIndex') || 0);
    const setActiveSlide = () => {
        setActiveIndex(swiperRef.current.swiper.activeIndex)
        localStorage.setItem('activeIndex', swiperRef.current.swiper.activeIndex)
    }

    /**
     * Воспроизведение / пауза видео
     */
    const [videoSvg, setVideoSvg] = useState(true);

    function mediaChange() {
        try {
            const video = videoRef.current;
            if (video.paused) {
                video.play();
                setVideoSvg(false);
            } else {
                video.pause();
                setVideoSvg(true);
            }
            video.onended = (e) => {
                setVideoSvg(true);
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    const params = {
        speed: 1000,
        parallax: true,
        initialSlide: activeIndex,
        autoHeight: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        // allowTouchMove: false, // Отключить свайп на мобильных
        modules: [Parallax, Navigation, Pagination, EffectCoverflow],
        onSlideChange: (swiper) => {
            goTop();
            setActiveSlide();
        }
    }

    return (
        <section className={`section section__envieMobile`}>
            <Swiper ref={swiperRef} {...params}>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__one`}>
                        <img src={`/storage/img/collections/envie/mobile/slideOne.png`}
                             alt={`img`}
                             title={`img`}
                        />
                        <div className={`envieContentMobile envieContentMobile__one`}
                             data-swiper-parallax={`-3000`}
                        >
                            <p className={`title title__one`}>Envie d'été</p>
                            <Link href={`/catalog/envie-dete`}
                                  className={`btn btn__envieMobile`}
                            >
                                Коллекция украшений
                            </Link>
                            <div className={`envieVideoMobile`}>
                                <video ref={videoRef}
                                       preload={`none`}
                                       width={`100%`}
                                       poster={`/storage/img/collections/envie/mobile.jpg`}
                                >
                                    <source
                                        src={`${uploadUrl}/media/video/collections/envie/envie_mobile_mp4.mp4`}
                                        type={`video/mp4`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/envie/envie_mobile_webm.webm`}
                                        type={`video/webm`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/envie/envie_mobile_ogg.ogg`}
                                        type={`video/ogg`} />
                                </video>
                                <div className={`video-control`}>
                                    {videoSvg ?
                                        <>
                                            <div className={`gg-play-button`}
                                                 onClick={mediaChange}></div>
                                        </>
                                        :
                                        <>
                                            <div className={`gg-pause-button`}
                                                 onClick={mediaChange}></div>
                                        </>
                                    }
                                </div>
                            </div>
                            <p className={`text`}>
                                Ювелирный бренд PLATINA представляет серебряную коллекцию, вдохновлённую миром
                                цветов и насекомых.
                            </p>
                            <p className={`text`}>
                                Наши украшения в стиле флора и фауна станут модным элементом вашего чарующего
                                летнего образа!
                            </p>
                            <div className={`btn btn__envieMobile`} onClick={goNext}>
                                Смотреть украшения
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__two`}>
                        <img className={`sheetMobile sheetMobile__one`}
                             src={`/storage/img/collections/envie/mobile/leaf-1.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`}
                             title={`img`}
                        />
                        <img className={`sheetMobile sheetMobile__two`}
                             src={`/storage/img/collections/envie/mobile/leaf-2.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`}
                             title={`img`}
                        />
                        <img src={`/storage/img/collections/envie/mobile/slideTwo.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`}
                             title={`img`}
                        />
                        <div className={`envieContentMobile envieContentMobile__two`}
                             data-swiper-parallax={`-3000`}
                        >
                            <p className={`title title__two`}>Магия</p>
                            <p className={`subTitle subTitle__two`}>летних образов</p>
                        </div>
                        <Link href={`/catalog/product/03-3268-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3268-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`}
                                 title={`img`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4783-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4783-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`}
                                 title={`img`}
                            />
                        </Link>
                        <Link href={`/catalog/product/01-5484-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/01-5484-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`}
                                 title={`img`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0688-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__four `}
                                 src={`/storage/img/collections/envie/mobile/05-0688-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__three`}>
                        <img className={`sheetMobile sheetMobile__three`}
                             src={`/storage/img/collections/envie/mobile/leaf-3.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__four`}
                             src={`/storage/img/collections/envie/mobile/leaf-4.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__five`}
                             src={`/storage/img/collections/envie/mobile/leaf-5.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideThree.png`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__three`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__three`}>Красота</p>
                            <p className={`subTitle subTitle__three`}>чарующих силуэтов</p>
                        </div>
                        <Link href={`/catalog/product/03-3266-00-201-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3266-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0682-00-201-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/05-0682-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5483-00-201-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/01-5483-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4781-00-201-0200-68`}>
                            <img className={`imgSwiper imgSwiper__four `}
                                 src={`/storage/img/collections/envie/mobile/02-4781-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__four`}>
                        <img className={`sheetMobile sheetMobile__six`}
                             src={`/storage/img/collections/envie/mobile/leaf-6.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__seven`}
                             src={`/storage/img/collections/envie/mobile/leaf-7.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideFour.png`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__four`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__four`}>Сияние</p>
                            <p className={`subTitle subTitle__four`}>бездонной лазури</p>
                        </div>
                        <Link href={`/catalog/product/03-3264-00-201-0200-69`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3264-00-201-02000.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4779-00-201-0200-69`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4779-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0680-00-201-0200-69`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0680-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__five`}>
                        <img className={`sheetMobile sheetMobile__eight`}
                             src={`/storage/img/collections/envie/mobile/leaf-8.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__nine`}
                             src={`/storage/img/collections/envie/mobile/leaf-9.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__ten`}
                             src={`/storage/img/collections/envie/mobile/leaf-10.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideFive.png`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__five`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__five`}>Феерия</p>
                            <p className={`subTitle subTitle__five`}>летних красок</p>
                        </div>
                        <Link href={`/catalog/product/03-3270-00-000-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3270-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/04-0259-00-000-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/04-0259-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4785-00-000-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/02-4785-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5485-00-000-0200-68`}>
                            <img className={`imgSwiper imgSwiper__four`}
                                 src={`/storage/img/collections/envie/mobile/01-5485-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__six`}>
                        <img className={`sheetMobile sheetMobile__eleven`}
                             src={`/storage/img/collections/envie/mobile/leaf-11.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__twelve`}
                             src={`/storage/img/collections/envie/mobile/leaf-12.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideSix.png`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__six`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__six`}>Красота</p>
                            <p className={`subTitle subTitle__six`}>истинных символов</p>
                        </div>
                        <Link href={`/catalog/product/03-3263-00-404-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3263-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4778-00-404-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4778-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0679-00-404-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0679-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__seven`}>
                        <img className={`sheetMobile sheetMobile__thirteen`}
                             src={`/storage/img/collections/envie/mobile/leaf-13.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__fourteen`}
                             src={`/storage/img/collections/envie/mobile/leaf-14.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideSeven.png`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__seven`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__seven`}>Настроение</p>
                            <p className={`subTitle subTitle__seven`}>яркого лета</p>
                        </div>
                        <Link href={`/catalog/product/03-3269-00-404-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3269-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4784-00-404-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4784-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0683-00-404-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0683-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__eight`}>
                        <img className={`sheetMobile sheetMobile__fifteen`}
                             src={`/storage/img/collections/envie/mobile/leaf-15.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__sixteen`}
                             src={`/storage/img/collections/envie/mobile/leaf-16.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideEight.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__eight`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__eight`}>Сияние</p>
                            <p className={`subTitle subTitle__eight`}>фактуры цвета</p>
                        </div>
                        <Link href={`/catalog/product/03-3267-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3267-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4782-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4782-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0689-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0689-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__nine`}>
                        <img className={`sheetMobile sheetMobile__seventeen`}
                             src={`/storage/img/collections/envie/mobile/leaf-17.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__eighteen`}
                             src={`/storage/img/collections/envie/mobile/leaf-18.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__nineteen`}
                             src={`/storage/img/collections/envie/mobile/leaf-19.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideNine.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__nine`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__nine`}>Феерия</p>
                            <p className={`subTitle subTitle__nine`}>ажурных силуэтов</p>
                        </div>
                        <Link href={`/catalog/product/02-4780-00-203-0200-69`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/02-4780-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/03-3265-00-203-0200-69`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/03-3265-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0687-00-203-0200-69`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0687-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5482-00-203-0200-69`}>
                            <img className={`imgSwiper imgSwiper__four`}
                                 src={`/storage/img/collections/envie/mobile/01-5482-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__ten`}>
                        <img className={`sheetMobile sheetMobile__twenty`}
                             src={`/storage/img/collections/envie/mobile/leaf-20.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__twentyOne`}
                             src={`/storage/img/collections/envie/mobile/leaf-21.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__twentyTwo`}
                             src={`/storage/img/collections/envie/mobile/leaf-22.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideTen.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__ten`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__ten`}>Романтика</p>
                            <p className={`subTitle subTitle__ten`}>летних цветов</p>
                        </div>
                        <Link href={`/catalog/product/03-3272-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3272-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4792-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4792-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5490-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/01-5490-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0691-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__four`}
                                 src={`/storage/img/collections/envie/mobile/05-0691-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/03-3274-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__five`}
                                 src={`/storage/img/collections/envie/mobile/03-3274-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4795-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__six`}
                                 src={`/storage/img/collections/envie/mobile/02-4795-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4796-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__seven`}
                                 src={`/storage/img/collections/envie/mobile/02-4796-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__eleven`}>
                        <img className={`sheetMobile sheetMobile__twentyThree`}
                             src={`/storage/img/collections/envie/mobile/leaf-23.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__twentyFour`}
                             src={`/storage/img/collections/envie/mobile/leaf-24.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__twentyFive`}
                             src={`/storage/img/collections/envie/mobile/leaf-25.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideEleven.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__eleven`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__eleven`}>Магия</p>
                            <p className={`subTitle subTitle__eleven`}>натуральных аметистов</p>
                        </div>
                        <Link href={`/catalog/product/02-4798-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/02-4798-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5492-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/01-5492-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0694-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0694-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4799-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__four`}
                                 src={`/storage/img/collections/envie/mobile/02-4799-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4800-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__five`}
                                 src={`/storage/img/collections/envie/mobile/02-4800-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0693-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__six`}
                                 src={`/storage/img/collections/envie/mobile/05-0693-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__twelve`}>
                        <img className={`sheetMobile sheetMobile__twentySix`}
                             src={`/storage/img/collections/envie/mobile/leaf-26.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__twentySeven`}
                             src={`/storage/img/collections/envie/mobile/leaf-27.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__twentyEight`}
                             src={`/storage/img/collections/envie/mobile/leaf-28.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideTwelve.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__twelve`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__twelve`}>Настроение</p>
                            <p className={`subTitle subTitle__twelve`}>летних приключений</p>
                        </div>
                        <Link href={`/catalog/product/03-3271-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3271-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4789-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4789-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0690-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0690-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5489-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__four`}
                                 src={`/storage/img/collections/envie/mobile/01-5489-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4791-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__five`}
                                 src={`/storage/img/collections/envie/mobile/02-4791-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4790-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__six`}
                                 src={`/storage/img/collections/envie/mobile/02-4790-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4788-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__seven`}
                                 src={`/storage/img/collections/envie/mobile/02-4788-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__thirteen`}>
                        <img className={`sheetMobile sheetMobile__twentyNine`}
                             src={`/storage/img/collections/envie/mobile/leaf-29.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img className={`sheetMobile sheetMobile__thirty`}
                             src={`/storage/img/collections/envie/mobile/leaf-30.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideThirteen.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__thirteen`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`title title__thirteen`}>Романтика</p>
                            <p className={`subTitle subTitle__thirteen`}>летнего очарования</p>
                        </div>
                        <Link href={`/catalog/product/03-3273-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/03-3273-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4793-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/02-4793-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/05-0692-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/05-0692-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5491-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__four`}
                                 src={`/storage/img/collections/envie/mobile/01-5491-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4797-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__five`}
                                 src={`/storage/img/collections/envie/mobile/02-4797-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/02-4794-00-204-0200-69`}>
                            <img className={`imgSwiper imgSwiper__six`}
                                 src={`/storage/img/collections/envie/mobile/02-4794-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`SwiperBoxMobile SwiperBoxMobile__fourteen`}>
                        <img className={`sheetMobile sheetMobile__thirtyOne`}
                             src={`/storage/img/collections/envie/mobile/leaf-31.png`}
                             data-swiper-parallax={`-1000`}
                             alt={`img`} />
                        <img src={`/storage/img/collections/envie/mobile/slideFourteen.png`}
                            // data-swiper-parallax={`-2000`}
                             alt={`img`} />
                        <div className={`envieContentMobile envieContentMobile__fourteen`}
                             data-swiper-parallax={`-3000`}>
                            <p className={`description description__fourteen`}>
                                Хотите ближе познакомиться с&nbsp;эффектными силуэтами бабочек, очаровательных
                                жуков, лёгких ветвей и&nbsp;элегантных соцветий?
                            </p>
                            <Link href={`/catalog/envie-dete`}
                                  className={`subTitle subTitle__fourteen`}
                            >
                                перейти к украшениям
                            </Link>
                        </div>
                        <Link href={`/catalog/product/02-4782-00-203-0200-68`}>
                            <img className={`imgSwiper imgSwiper__one`}
                                 src={`/storage/img/collections/envie/mobile/02-4782-00-203-0200-68.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/01-5490-00-206-0200-68`}>
                            <img className={`imgSwiper imgSwiper__two`}
                                 src={`/storage/img/collections/envie/mobile/01-5490-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                        <Link href={`/catalog/product/03-3269-00-404-0200-68`}>
                            <img className={`imgSwiper imgSwiper__three`}
                                 src={`/storage/img/collections/envie/mobile/03-3269-00-404-0200-68.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`img`} />
                        </Link>
                    </div>
                </SwiperSlide>
                {swiperRef.current !== null && swiperRef.current.swiper !== null && !swiperRef.current.swiper.isBeginning && (
                    <img src={`/storage/img/collections/envie/mobile/envieArrowLeft.png`}
                         alt={`arrow`}
                         onClick={goPrev}
                         className={`envieMobile js-swiper-button-prev`} />
                )}
                {swiperRef.current !== null && swiperRef.current.swiper !== null && swiperRef.current.swiper.realIndex !== 0 && (
                    <>
                        <img src={`/storage/img/collections/envie/mobile/envieArrowTop.png`}
                             alt={`arrow`}
                             onClick={goTop}
                             className={`envieMobile envieMobile__top envieMobile__center`} />
                        {swiperRef.current !== null && swiperRef.current.swiper !== null && !swiperRef.current.swiper.isEnd && (
                            <img src={`/storage/img/collections/envie/mobile/envieArrowRight.png`}
                                 alt={`arrow`}
                                 onClick={goNext}
                                 className={`envieMobile envieMobile__right js-swiper-button-next`} />
                        )}
                    </>
                )}
            </Swiper>
        </section>
    );
};
